import styled, { keyframes } from 'styled-components'

const move = keyframes`
  0% {
      transform: scale(1.3) translate3d( -12%, 12%, 0 );
  }
  25% {
      transform: scale(1.3) translate3d( 12%, -12%, 0 );
  }
  50% {
      transform: scale(1.3) translate3d( 12%, 12%, 0 );
  }
  75% {
      transform: scale(1.3) translate3d( -12%, -12%, 0 );
  }
  100% {
      transform: scale(1.3) translate3d( -12%, 12%, 0 );
  }
`

const Wrapper = styled.div`
  .slide-wrap {
    transition: height 0.3s ease;
    &.wrap-enter-active {
      height: 100vh;
    }
    &.wrap-enter-done {
      height: 100vh;
    }
  }

  /* overflow: hidden; */
`

const Overlay = styled.div`
  .selected {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f6eaec;

    transition: all 1s ease;
    transform: translateX(200vw);
    padding: 2rem;
    height: 100%;
    width: 100vw;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .delayed {
      opacity: 0;
      transition: all 1s;
    }
  }

  .selectedwrap-enter {
  }

  .selectedwrap-exit {
    .delayed {
      opacity: 0;
    }
  }

  .selectedwrap-exit-done {
    .delayed {
      opacity: 0;
    }
  }
  .selectedwrap-enter-active {
    transform: translateX(0);
    background-color: #e9c20b;
  }
  .selectedwrap-enter-done {
    transform: translateX(0);
    background-color: #e9c20b;

    .delayed {
      opacity: 1;
    }
    .delayed1 {
      transition-delay: 1.5s;
    }
    .delayed2 {
      transition-delay: 2.5s;
    }
  }
`
const Children = styled.div``
export { Wrapper, Overlay, Children }
